import React from 'react';

import { RootMenuItem } from '../../types';
import {
  ConstantMenuItem,
  MENU_ITEM_TYPE,
  SportMenuItemNative,
} from 'app/modules/Navigation/types';

import { Icon } from 'app/design-system/components/Icon';
import { ImagePreloader } from 'app/design-system/components/ImagePreloader';
import { IconName } from 'app/design-system/types/Icon';
import { useTranslation } from 'app/lang';
import { getSportKey } from 'app/lib/betting/sport-utils';
import { defaultTournamentLogo } from 'app/lib/compose-image-src';
import { composeImageSrcFromCDN } from 'app/lib/compose-image-src/compareImagesFromCDN';

import dictionary from './Icon.dictionary.json';

import styles from '../../styles/LeftMenu.module.scss';

// --

const CONSTANT_MENU_ITEM_ICONS: Record<string, IconName> = {
  prematch: 'fire',
  live: 'live',
  favorites: 'star',
  announcement: 'megaphone',
};

const MENU_TOURNAMENT_LOGO_SIZE = 24;

const getConstantMenuItemIconName = (entry: ConstantMenuItem): IconName => {
  return CONSTANT_MENU_ITEM_ICONS[entry.key];
};

const getSportIconName = (entry: SportMenuItemNative): IconName => {
  return `sport-${getSportKey(entry.sportId)}` as IconName;
};

// --

type RootMenuIconProps = {
  entry: RootMenuItem;
};

const RootMenuIcon: React.FC<RootMenuIconProps> = ({ entry }) => {
  const { t } = useTranslation();
  switch (entry.type) {
    case MENU_ITEM_TYPE.CONSTANT:
      return (
        <Icon icon={getConstantMenuItemIconName(entry)} />
      );

    case MENU_ITEM_TYPE.SPORT:
      return (
        <Icon icon={getSportIconName(entry)} />
      );

    case MENU_ITEM_TYPE.TOURNAMENT:
      return (
        <ImagePreloader
          imageSrc={composeImageSrcFromCDN('tournaments', MENU_TOURNAMENT_LOGO_SIZE, entry.tournamentId)}
          className={styles.imagePreloader}
          defaultImage={defaultTournamentLogo}
          height={MENU_TOURNAMENT_LOGO_SIZE}
          width={MENU_TOURNAMENT_LOGO_SIZE}
          alt={t(dictionary.alt, { label: entry.label })} />
      );

    case MENU_ITEM_TYPE.UNION:
      return (
        <ImagePreloader
          imageSrc={composeImageSrcFromCDN('unions', MENU_TOURNAMENT_LOGO_SIZE, entry.unionId)}
          className={styles.imagePreloader}
          defaultImage={defaultTournamentLogo}
          height={MENU_TOURNAMENT_LOGO_SIZE}
          width={MENU_TOURNAMENT_LOGO_SIZE}
          alt={t(dictionary.alt, { label: entry.label })} />
      );

    case MENU_ITEM_TYPE.STAGE:
      return (
        <ImagePreloader
          imageSrc={composeImageSrcFromCDN('tournaments', MENU_TOURNAMENT_LOGO_SIZE, entry.entity.tournamentId)}
          className={styles.imagePreloader}
          defaultImage={defaultTournamentLogo}
          height={MENU_TOURNAMENT_LOGO_SIZE}
          width={MENU_TOURNAMENT_LOGO_SIZE}
          alt={t(dictionary.alt, { label: entry.label })} />
      );

    default:
      return (
        <div className={styles.iconStub} />
      );
  }
};

export default RootMenuIcon;
